import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import styled, { css } from 'styled-components'
import { iconButtonStyles } from 'styles/mixins'

export const Button = styled.button<{
  $disabled?: boolean
  $hasTitle?: boolean
}>`
  ${({ $disabled }) => iconButtonStyles($disabled)}

  ${({ $hasTitle }) =>
    $hasTitle
      ? css`
          width: 100%;
          justify-content: flex-start;
          gap: 8px;
        `
      : css`
          @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
            width: 28px;
            height: 21px;
          }
        `}
`
